<template>
    <div class="zh-trade-query-root" :class="{ 'zh-trade-query-root-mobile': isMobileByUserAgent }">
        <div class="trade-query-wrap min-w center" :class="{ center: true, 'mobile-trade-query-wrap': isMobileByUserAgent }">
            <!-- 非移动端 -->
            <template v-if="!isMobileByUserAgent">
                <PageTitle :title="t[lang].tradeNoQuery" />
                <div class="search-limit-tips t-center">{{ t[lang].tradeLenLimitTips }}</div>
            </template>
            <!-- 移动端 -->
            <template v-else>
                <div class="mobile-title">
                    <div class="title" :style="{ color: '#333', marginTop: '0px' }">{{ t[lang].tradeNoQuery }}</div>
                    <div class="line">
                        <img src="./assets/xiaobiao@2x.png" />
                    </div>
                </div>
                <div class="mobile-search-limit-tips">{{ t[lang].tradeLenLimitTips }}</div>
                <div class="mobile-search-limit-tips2">{{ t[lang].inSearchTips }}</div>
            </template>

            <ZhTradeInput ref="tradeInputDom" :origin="'trail'" @queryTrail="queryTrail" :lang="lang" />
            <!-- <div class="code-img-form-item">
                <div>
                    <div class="code-img-input-wrap">
                        <el-input minlength="4" maxlength="4" v-model.trim="verificationCode" autocomplete="off" width="50%" class="code-img-input" :placeholder="t[lang].verificationTip"></el-input>
                    </div>
                    <div class="code-img-wrap">
                        <img :src="`https://bk.diditrack.com/track/verificationCode?${random}`" @click="random = Math.random()" />
                    </div>
                </div>
            </div> -->
            <!-- 非移动端 -->
            <!-- <div class="safe-title" v-if="!isMobileByUserAgent">
                {{ t[lang].safetyCertificate }}
            </div> -->
            <!-- 移动端 -->
            <a v-if="isMobileByUserAgent" @click="queryTrail" class="mobile-btn_search"> <img src="./assets/btn_search.png" />{{ t[lang].tradeNoQuery }}</a>
        </div>
        <div class="result-header min-w center" v-if="trailData.length">
            <div class="result-header-desc">{{ t[lang].searchRes }}</div>
            <div class="result-header-tips mt-20">
                <span>{{ t[lang].trailTip1 }}</span>
                <span class="green">{{ t[lang].trailTip2 }}</span>
                <span>{{ t[lang].trailTip3 }}</span>
            </div>
        </div>
        <Trail v-for="item in trailData" :key="item.tradeNo" :trailObjItem="item" :lang="lang" />
    </div>
</template>

<script>
import Trail from './Trail'
import ZhTradeInput from './TradeInput'
import PageTitle from './PageTitle'
import t from './config'
import { querySeaTrack } from './services/app'

// 域名映射轨迹来源字段
// locale映射语言
// const localeMapLang = {
//     zh: 1,
//     en: 2,
//     local: 3
// }

// lang字段 中文zh 英文en 柬埔寨语km
// 运输类型：shipType
// 耗时：usedTime
// 柬埔寨：intl.cambodia
// 香港：zto.xianggang.find

export default {
    name: 'HOME',
    data() {
        return {
            loading: false,
            // verificationCode: '',
            // random: undefined, // 验证码随机数
            trailData: [],
            lang: 'zh',
            lggType: 1, // 1是中文 2是英文 3是本地语
            t,
            isMobileByUserAgent: /(Android|webOS|iPhone|iPod|tablet|BlackBerry|Mobile)/i.test(navigator.userAgent) ? true : false,
        }
    },
    layout: 'tradePage',
    components: { ZhTradeInput, Trail, PageTitle },
    mounted() {
        // this.getStorageTrailData()
    },
    methods: {
        // 查询轨迹
        queryTrail() {
            if (this.loading) return

            this.getQueryTrailNo()
        },
        // 获取运单号
        getQueryTrailNo() {
            let tradeNo = this.$refs.tradeInputDom.tradeNo
            let tradeNoArr = this.$refs.tradeInputDom.tradeNoArr

            const valueArr = tradeNo.split(' ').filter((item) => item !== '')

            this.$refs.tradeInputDom.tradeNo = ''
            if (valueArr.length + tradeNoArr.length > 50 || (!tradeNo && tradeNoArr.length > 50)) {
                this.$message({
                    type: 'warning',
                    message: this.t[this.lang].NoLenlimitTip,
                })
                return
            }
            // // 运单号重复
            // if (tradeNoArr.includes(tradeNo)) {
            //     this.$message({
            //         type: 'warning',
            //         message: this.t[this.lang].NoRepeatTip,
            //     })
            //     return
            // }
            // tradeNo && tradeNoArr.push(tradeNo)
            // 运单号重复
            if (tradeNoArr.some((item) => valueArr.includes(item))) {
                this.$message({
                    type: 'warning',
                    message: this.t[this.lang].NoRepeatTip,
                })
                return
            }
            if (valueArr.length > 0) {
                valueArr.forEach((noStr) => {
                    tradeNoArr.push(noStr)
                })
            }
            if (this.validForm(tradeNoArr)) {
                window.secVerify.popupVerify(
                    { appid: 'diditrack', eventType: 'queryTrack' }, // 这里的appid请提供高峰期用量后, 向 @张肖辉 索取, eventType为业务方定义
                    (result) => {
                        console.log(result)
                        // alert('验证结果: ' + JSON.stringify(result) + ' 前端流程完毕, 将verifyId与业务接口的正常提交内容一起传给后端即可')
                        if (result.passed) {
                            this.reqQueryTrail(tradeNoArr, result.verifyId)
                        }
                    }
                )
            }
        },
        // 请求接口查询轨迹
        async reqQueryTrail(tradeNoArr, verifyId) {
            let params = {
                clientSource: 'SZDYCUSTOM',
                lggType: 1,
                data: tradeNoArr,
                verifyId,
                // verificationCode: this.verificationCode,
            }

            this.loading = true
            let res = await querySeaTrack(params)
            this.loading = false
            // this.random = Math.random()
            // this.verificationCode = ''
            if (res.success) {
                this.handleTrailData(tradeNoArr, res.data.data)
            }
        },
        // 处理接口轨迹数据
        handleTrailData(tradeNoArr, data) {
            let trailData
            if (data.length) {
                trailData = data.map((v) => ({
                    tradeNo: v.mail.mailNo,
                    trail: v.tracks,
                    shipType: v.shipType,
                    usedTime: v.usedTime,
                }))
            } else {
                trailData = [{ tradeNo: '', trail: [], shipType: '', usedTime: '' }]
            }
            this.trailData = trailData

            // this.trailData = tradeNoArr.map(item1 => {
            //     for (let index = 0; index < data.length; index++) {
            //         if (data[index] && data[index].mail) {
            //             return {
            //                 tradeNo: data[index].mail.mailNo,
            //                 trail: data[index].tracks
            //             }
            //         }
            //     }
            //     return {
            //         tradeNo: item1,
            //         trail: []
            //     }
            // })
        },
        // 校验表单
        validForm(tradeNoArr) {
            if (!tradeNoArr.length) {
                this.$message({
                    type: 'warning',
                    message: this.t[this.lang].tradeTip,
                })
                return false
            }
            // if (!this.verificationCode) {
            //     this.$message({
            //         type: 'warning',
            //         message: this.t[this.lang].verificationTip,
            //     })
            //     return false
            // }
            return true
        },
        // 轨迹查询页面需获取缓存的轨迹记录
        getStorageTrailData() {
            this.trailData = sessionStorage.getItem('ztoglobal_trailData') ? JSON.parse(sessionStorage.getItem('ztoglobal_trailData')) : []
            if (sessionStorage.getItem('ztoglobal_trailData')) {
                sessionStorage.removeItem('ztoglobal_trailData')
            }
        },
    },
}
</script>

<style lang="scss">
.zh-trade-query-root {
    overflow: auto;
    background: #fff;
    padding: 24px;
    box-sizing: border-box;
    min-height: 100vh;
    .trade-query-wrap {
        background: linear-gradient(180deg, #fcfdff 0%, #f8fbff 100%);
        border-radius: 10px;
        padding: 30px 55px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .search-limit-tips {
            margin-top: -10px;
            font-size: 16px;
            color: #999;
        }

        .btn_search {
            display: block;
            width: 270px;
            height: 58px;
            line-height: 58px;
            background: linear-gradient(180deg, #01b1f3 0%, #004da0 100%);
            border: none;
            border-radius: 40px;
            font-size: 16px;
            color: #fff;
            font-weight: bolder;

            img {
                vertical-align: middle;
                width: 16px;
                margin-right: 10px;
            }
        }

        .code-img-form-item {
            margin: 20px 0 0 0;
            display: flex;
            justify-content: center;

            .code-img-input-wrap {
                display: inline-block;
                width: 160px !important;

                .el-input__inner {
                    border: 1px solid #dce2e7;
                    background: #f7f9fa;
                }
            }

            .code-img-wrap {
                display: inline-block;
                vertical-align: top;
                width: 120px;
                height: 40px;
                margin-left: 20px;
                background: rgba(254, 254, 254, 1);
                border: 1px solid rgba(220, 226, 231, 1);
                text-align: center;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .mobile-trade-query-wrap {
        padding-top: 0 !important;
    }

    .result-header {
        .result-header-desc {
            font-size: 20px;
            font-weight: bolder;
        }

        .result-header-tips {
            margin: 10px 0 20px;
            font-size: 14px;
            color: #999;
        }
    }

    .safe-title {
        font-size: 20px;
        font-weight: bolder;
        text-align: center;
        padding-top: 18px;
    }
}

.zh-trade-query-root-mobile {
    // padding: 12px;
    height: 100vh;
    overflow-y: scroll;
    padding: 0;
    .min-w {
        width: auto;
    }
    .trade-query-wrap {
        padding: 12px;
    }
    .header-wrap .content-wrap {
        padding-left: 16px;
    }
    .page-title {
        .content {
            width: 100%;
            .main-title {
                font-size: 24px;
                margin-bottom: 10px;
            }
        }
    }
    .zh-trade-input-wrap {
        .search-input-icon {
            width: 18px;
            margin: 0 0 0 12px;
        }
        .trade-list-wrap {
            padding: 12px 12px 0;
        }
        .trade-textarea-wrap {
            display: flex;
            align-items: center;
            .el-input {
                width: 100%;
                height: 55px;
                font-size: 16px;
                &.mulLen {
                    height: 83px;
                }
            }
            .el-input__inner {
                background: #f1f8ff;
                // background: red;
                padding-left: 12px;
                box-sizing: border-box;
                overflow: hidden; // 隐藏IE11以下滚动条样式
                resize: none;
                border: none;
                height: 100%;
                &::-webkit-input-placeholder {
                    font-size: 12px;
                    color: rgba(106, 106, 106, 0.7);
                    white-space: pre-wrap;
                    top: 0;
                    position: relative;
                }
            }
            .el-input__inner {
                resize: none;
                border: none;
            }
            .el-input ::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: 16px;
            }
            .el-input ::-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                font-size: 16px;
            }
            .el-input ::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                font-size: 16px;
            }
            .el-input ::-ms-input-placeholder {
                /* Internet Explorer 10+ */
                font-size: 16px;
            }
            .btn_search {
                display: block;
                width: 200px;
                height: 48px;
                line-height: 48px;
                background: linear-gradient(180deg, #01b1f3 0%, #004da0 100%);
                border: none;
                border-radius: 40px;
                font-size: 12px;
                color: #fff;
                font-weight: bolder;

                img {
                    vertical-align: middle;
                    width: 16px;
                    margin-right: 10px;
                }
            }
            .btn_search_pd {
                margin-bottom: 12px;
                margin-right: 12px;
            }
        }
    }
    .result-header {
        padding: 0 16px;
    }
    .zh-trail-wrap {
        padding: 0 12px 12px;
        .trail-info-wrap {
            height: auto;
            max-height: 480px;
            overflow-y: scroll;
        }
        .el-card__header {
            padding: 12px 20px;
        }
        .trail-child {
            padding: 16px;
            .trail-child-header {
                display: block;
                .trail-child-header-tags {
                    .trail-child-header-tag {
                        font-size: 12px;
                        margin-right: 12px;
                    }
                }
            }
        }
    }
}
.mobile-title {
    margin-top: 80px;
    .title {
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        display: flex;
        align-items: center;
        letter-spacing: normal;
        color: #000000;
    }
    .line {
        img {
            width: 66px;
            height: 6px;
        }
    }
}
.mobile-search-limit-tips {
    margin-top: 10px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: normal;
    color: #cccccc;
    font-size: 14px;
}
.mobile-search-limit-tips2 {
    margin-top: 10px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    line-height: 20px;
    display: flex;
    align-items: center;
    letter-spacing: normal;
    color: #999999;
    font-size: 14px;
}
.mobile-btn_search {
    cursor: pointer;
    margin: 0 auto;
    // margin: 10px 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    height: 46px;
    line-height: 46px;
    background: linear-gradient(180deg, #01b1f3 0%, #004da0 100%);
    border: none;
    border-radius: 40px;
    font-size: 16px;
    color: #fff;
    font-weight: bolder;
    margin-top: 25px;
    margin-bottom: 20px;

    img {
        vertical-align: middle;
        width: 16px;
        margin-right: 10px;
    }
}
</style>
